/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import type IntlService from 'embercom/services/intl';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class Connect extends Route {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  reactEnabled() {
    return this.appService.app.canUseStandaloneConnectPage;
  }

  get titleToken() {
    return this.intl.t('standalone.navbar.connect');
  }
}

export default ReactRoute(Connect);
